import { useMatch } from "react-router-dom";
import { SITE_MATCH_PATTERNS } from "@/routes/paths";

const [CONTROL, HEALTH, HEALTH_RECORDS, CCTV, CCTV_PLAYBACK] = SITE_MATCH_PATTERNS;

/**
 * `useParams()` 를 쓰면 안 된다 — 이 훅을 쓰는 쪽은 경로 없는 레이아웃(`MobileShell`)
 * 안에 있어서 자식이 잡은 파라미터를 못 본다. 경로를 직접 맞춰야 한다.
 */
export function useCurrentSiteId(): number | null {
  const control = useMatch(CONTROL);
  const health = useMatch(HEALTH);
  const healthRecords = useMatch(HEALTH_RECORDS);
  const cctv = useMatch(CCTV);
  const playback = useMatch(CCTV_PLAYBACK);

  const raw =
    control?.params.siteId ??
    health?.params.siteId ??
    healthRecords?.params.siteId ??
    cctv?.params.siteId ??
    playback?.params.siteId;
  if (!raw) return null;
  const id = Number(raw);
  return Number.isFinite(id) ? id : null;
}
